export default {
    buttons: {
        change_role: 'Promeni ulogu',
        delete_company_user: 'Obriši korisnika iz kompanije',
        save: 'Sačuvaj',
        add_user: 'Dodaj korisnika',
        show_user: 'Prikaži na javnim stranicama',
        show_public_profile: 'Dozvoli javni prikaz profila',
    },
    fields: {
        company_role: {
            label: 'Uloga u kompaniji',
            placeholder: 'Odaberite ulogu u kompaniji',
        },
    },
}
